import { CertificateData, Me, MeViewedHints, TeacherProfile } from '@yandex-int/k-common';
import * as api from '@yandex-int/k-common/client/api';
import isEqual from 'lodash/isEqual';
import { showNetworkError } from 'platform-components';
import { getHints, getMe } from 'platform-components/src/components/user/selectors';
import { reportMessage } from 'platform-components/utils';
import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import { addViewedHint, setTeacherProfile } from 'common.components/user/actions';
import { getTeacherProfile } from 'common.components/user/selectors';
import { VIEWED_HINTS_CERT_EXPANDED_PARAMS_KEY } from 'common.components/user/user.constants';

import { actions } from './actions';

export function* teacherCertificatesWatcher() {
    yield all([
        takeLatest(actions.getReadyCertificatesRequest, getReadyCertificatesSaga),
        takeLatest(actions.setCertificatesParamsRequest, saveCertificatesParamsSaga),
        takeLatest(actions.postCertExpandedParamsRequest, postCertificatesExpandedParamsSaga),
    ]);
}

function* getReadyCertificatesSaga() {
    try {
        const certificates: CertificateData[] = yield call(api.getCertificatesMentor);

        yield put(actions.setReadyCertificates(certificates));
    } catch (error) {
        console.error(error);
        reportMessage(`Произошла ошибка (${error.status}) при получении сертификатов`, error.message);

        yield put(actions.reportReadyCertificatesError());
    }
}

function* saveCertificatesParamsSaga(action: ReturnType<typeof actions.setCertificatesParamsRequest>) {
    const params = action.payload;

    try {
        const me: Me | null = yield select(getMe);
        const currentProfile: TeacherProfile = yield select(getTeacherProfile);

        const data = { meId: me?.id || 0, teacherProfile: { ...currentProfile, cert_gen_params: params } };
        api.patchTeacherProfile(data);
        const newTeacherProfile: TeacherProfile = yield call(api.patchTeacherProfile, data);

        yield put(setTeacherProfile(newTeacherProfile));
        yield put(actions.setCertificatesParamsSuccess());
    } catch (error) {
        console.error(error);
        yield put(actions.setCertificatesParamsError());
        yield put(showNetworkError());
    }
}

function* postCertificatesExpandedParamsSaga(action: ReturnType<typeof actions.postCertExpandedParamsRequest>) {
    const params = action.payload;

    try {
        const hints: MeViewedHints | undefined = yield select(getHints);
        const mergedHints = { ...hints, [VIEWED_HINTS_CERT_EXPANDED_PARAMS_KEY]: params };

        if (!isEqual(mergedHints, hints)) {
            yield put(addViewedHint(VIEWED_HINTS_CERT_EXPANDED_PARAMS_KEY, { ...params }));
        }

        yield put(actions.postCertExpandedParamsSuccess());
    } catch (error) {
        console.error(error);
        yield put(actions.postCertExpandedParamsError());
        yield put(showNetworkError());
    }
}
